export default "__VITE_ASSET__m2yAZkhH__"